<c-card *transloco="let t">
    <c-card-body class="px-2">
  
            <c-row>
              <c-col md="12">
                <h1>{{ t('Dashboard Beta') }}</h1>
                <p>
                    {{ t('You are currently using the new Dashboard - this is in Beta, which means we are still fixing some minor issues and taking some feedback on the final version.') }}
                </p>

                <div class="row">
                  <div class="col-12 col-md-6">

                    <h3>{{ t('What\'s New') }}</h3>
                    <ul>
                      <li>{{ t('New Languages - French & Spanish') }}</li>  
                      <li>{{ t('Feature Management - simplify your dashboard view based on the features you need') }}</li>  
                      <li>{{ t('App Features - toggle the features your workers need in the app') }}</li>  
                      <li>{{ t('Optional Check in Timer - turn off the check in timer if you don\'t need it') }}</li>  
                      <li>{{ t('Auto End Shifts - automatically end shifts each day to stop late night false alerts') }}</li>  
                      <li>{{ t('Microsoft SSO - login with your Microsoft account') }}</li>  
                      <li>{{ t('Safety Zone - group your workers by zone and easily see where they are') }}</li>  
                      <li>{{ t('Worker Upload - easily upload your workers from excel or csv') }}</li>  
                    </ul>
    
                    <p>
                        {{ t('If you have any issues please email us at ') }}<a href="mailto:customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a>.
                    </p>
    
                    <div class="form-floating mb-2">
                      <textarea class="form-control" placeholder="Leave a comment here" id="floatingTextarea" style="max-width:500px;" [(ngModel)]="why"></textarea>
                      <label for="floatingTextarea">{{ t('Why are you going back?') }}</label>
                      <span class="text-danger" *ngIf="error">{{ t('Please enter a reason why you are returning to the old dashboard.')}}</span>
                    </div>
    
                    <button type="button" class="btn btn-info text-white" (click)="cancelBeta()"><i class="fa-solid fa-rotate-left"></i> {{ t('Return to the Original Dashboard') }}</button>

                  </div>

                  <div class="col-12 col-md-6">

                    <div class="embed-container"><iframe src="https://www.youtube.com/embed/FXpUpVwdHbo" frameborder="0" allowfullscreen></iframe></div>
                  </div>
                </div>



              </c-col>
            </c-row>

  
    </c-card-body>
  </c-card>
  
  
  